import Vue from 'vue';
import Router from 'vue-router';

import PageLogin from '@/views/Login.vue';
import PageLogout from '@/views/Logout.vue';
import PageServers from '@/views/Servers.vue';
import PageBans from '@/views/Bans.vue';
import PageClients from '@/views/Clients.vue';
import PageClientInfo from '@/views/ClientInfo.vue';

import ChatLogs from '@/views/Chatlogs.vue';

// Server specific pages
import PageServerDeathrun from '@/views/ServerDeathrun.vue';
import PageServerSurf from '@/views/ServerSurf.vue';
import PageServerPromod from '@/views/ServerPromod.vue';
import PageServerCombinedOps from '@/views/ServerCombinedOps.vue';
import PageServerPartyGames from '@/views/ServerPartyGames.vue';
import PageServerTDM from '@/views/ServerTDM.vue';
import PageServerSWGW from '@/views/ServerSWGW.vue';
import PageServerFun from '@/views/ServerFun.vue';

import PageServerCSGOAWP from '@/views/ServerCSGOAWP.vue';
import PageServerCSGO1v1 from '@/views/ServerCSGO1v1.vue';
import PageServerCSGORetakes from '@/views/ServerCSGORetakes.vue';
import PageServerCSGORetakes2 from '@/views/ServerCSGORetakes2.vue';
import PageServerCSGOExecutes from '@/views/ServerCSGOExecutes.vue';
import PageServerCSGOSurf from '@/views/ServerCSGOSurf.vue';
import PageServerCSGOCompetitive from '@/views/ServerCSGOCompetitive.vue';
import PageServerCSGODM from '@/views/ServerCSGODM.vue';

// Records pages
import PageRecordsDeathrun from '@/views/RecordsDeathrun.vue';
import PageRecordsSurf from '@/views/RecordsSurf.vue';

import PageRecordsAWP from '@/views/RecordsCSGOAWP.vue';
import PageRecords1v1 from '@/views/RecordsCSGO1v1.vue';
import PageRecordsRetakes from '@/views/RecordsCSGORetakes.vue';
import PageRecordsExecutes from '@/views/RecordsCSGOExecutes.vue';
import PageRecordsCSGOSurf from '@/views/RecordsCSGOSurf.vue';
import PageRecordsCompetitive from '@/views/RecordsCSGOCompetitive.vue';
import PageRecordsDM from '@/views/RecordsCSGODM.vue';

const config = require('@/config');

export default () => {
  Vue.use(Router);

  const routes = [
    {
      path: '/login',
      name: 'login',
      component: PageLogin,
      meta: {
        title: 'Sign In',
      },
    },
    {
      path: '/logout',
      name: 'logout',
      component: PageLogout,
      meta: {
        title: 'Sign Out',
      },
    },
    {
      path: '/',
      name: 'servers',
      component: PageServers,
      meta: {
        title: 'Servers',
      },
    },
    {
      path: '/chatlogs/:game',
      name: 'chatlogs-game',
      component: ChatLogs,
      meta: {
        title: 'Chatlogs',
      },
    },
    {
      path: '/deathrun',
      name: 'server-deathrun',
      component: PageServerDeathrun,
      meta: {
        title: 'Deathrun',
      },
    },
    {
      path: '/surf',
      name: 'server-surf',
      component: PageServerSurf,
      meta: {
        title: 'Surf',
      },
    },
    {
      path: '/promod',
      name: 'server-promod',
      component: PageServerPromod,
      meta: {
        title: 'Promod',
      },
    },
    {
      path: '/combined-ops',
      name: 'server-combined-ops',
      component: PageServerCombinedOps,
      meta: {
        title: 'Combined Operations',
      },
    },
    {
      path: '/tdm',
      name: 'server-tdm',
      component: PageServerTDM,
      meta: {
        title: 'Team Deathmatch',
      },
    },
    {
      path: '/star-wars',
      name: 'server-swgw',
      component: PageServerSWGW,
      meta: {
        title: 'Star Wars: Galactic Warfare',
      },
    },
    {
      path: '/fun',
      name: 'server-fun',
      component: PageServerFun,
      meta: {
        title: 'Fun/High Jump',
      },
    },
    {
      path: '/party-games',
      name: 'server-party-games',
      component: PageServerPartyGames,
      meta: {
        title: 'Party Games',
      },
    },
    {
      path: '/awp',
      name: 'server-csgo-awp',
      component: PageServerCSGOAWP,
      meta: {
        title: 'AWP Only',
      },
    },
    {
      path: '/multi1v1',
      name: 'server-csgo-1v1',
      component: PageServerCSGO1v1,
      meta: {
        title: 'Multi 1v1',
      },
    },
    {
      path: '/retakes',
      name: 'server-csgo-retakes',
      component: PageServerCSGORetakes,
      meta: {
        title: 'Retakes #1',
      },
    },
    {
      path: '/retakes2',
      name: 'server-csgo-retakes2',
      component: PageServerCSGORetakes2,
      meta: {
        title: 'Retakes #2',
      },
    },
    {
      path: '/executes',
      name: 'server-csgo-executes',
      component: PageServerCSGOExecutes,
      meta: {
        title: 'Executes',
      },
    },
    {
      path: '/csgo-surf',
      name: 'server-csgo-surf',
      component: PageServerCSGOSurf,
      meta: {
        title: 'CS:GO Surf',
      },
    },
    {
      path: '/competitive',
      name: 'server-csgo-competitive',
      component: PageServerCSGOCompetitive,
      meta: {
        title: 'Competitive',
      },
    },
    {
      path: '/dm',
      name: 'server-csgo-dm',
      component: PageServerCSGODM,
      meta: {
        title: 'WarmupServer FFA-DM',
      },
    },
    {
      path: '/deathrun/records/:map?',
      name: 'records-deathrun',
      component: PageRecordsDeathrun,
      meta: {
        title: 'Records - Deathrun',
      },
    },
    {
      path: '/surf/records/:map?/:filter?/:page?',
      name: 'records-surf',
      component: PageRecordsSurf,
      meta: {
        title: 'Leaderboards - Surf',
      },
    },
    {
      path: '/awp/records/:page?',
      name: 'records-csgo-awp',
      component: PageRecordsAWP,
      meta: {
        title: 'Leaderboards - AWP',
      },
    },
    {
      path: '/multi1v1/records/:page?',
      name: 'records-csgo-1v1',
      component: PageRecords1v1,
      meta: {
        title: 'Leaderboards - Multi 1v1',
      },
    },
    {
      path: '/retakes/records/:page?',
      name: 'records-csgo-retakes',
      component: PageRecordsRetakes,
      meta: {
        title: 'Leaderboards - Retakes',
      },
    },
    {
      path: '/executes/records/:page?',
      name: 'records-csgo-executes',
      component: PageRecordsExecutes,
      meta: {
        title: 'Leaderboards - Executes',
      },
    },
    {
      path: '/csgo-surf/records/:map?/:filter?/:page?',
      name: 'records-csgo-surf',
      component: PageRecordsCSGOSurf,
      meta: {
        title: 'Leaderboards - CS:GO Surf',
      },
    },
    {
      path: '/competitive/records/:page?',
      name: 'records-csgo-competitive',
      component: PageRecordsCompetitive,
      meta: {
        title: 'Leaderboards - Competitive 5v5',
      },
    },
    {
      path: '/dm/records/:page?',
      name: 'records-csgo-dm',
      component: PageRecordsDM,
      meta: {
        title: 'Leaderboards - WarmupServer FFA-DM',
      },
    },
    {
      path: '/bans/:page?',
      name: 'bans',
      component: PageBans,
      meta: {
        title: 'Bans',
      },
    },
    {
      path: '/clients/:page?',
      name: 'clients',
      component: PageClients,
      meta: {
        title: 'Clients',
      },
    },
    {
      path: '/client/:id',
      name: 'client',
      component: PageClientInfo,
      meta: {
        title: 'Client Info',
      },
    },
  ];

  const router = new Router({
    mode: 'history',
    base: config.baseUrl,
    routes,
  });

  router.beforeEach((to, from, next) => {
    const nearestWithTitle = to.matched
      .slice()
      .reverse()
      .find((r) => r.meta && r.meta.title);
    if (nearestWithTitle) {
      document.title = `${nearestWithTitle.meta.title} - ${config.siteName}`;
    }
    next();
  });

  return router;
};
